import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { cloneElement, PureComponent } from 'react';
import { pxToEm } from "../styles";
import IconDanger from "../Icon/IconDanger";
import IconSuccess from "../Icon/IconSuccess";
import IconWarning from "../Icon/IconWarning";
import { MenuItemRoot as Root, MenuItemContent, MenuItemInner, MenuItemSecondaryText, MenuItemText } from "./styled";
import { menuItemPropTypes } from "./propTypes";
var variantIcons = {
  danger: ___EmotionJSX(IconDanger, {
    size: pxToEm(24)
  }),
  success: ___EmotionJSX(IconSuccess, {
    size: pxToEm(24)
  }),
  warning: ___EmotionJSX(IconWarning, {
    size: pxToEm(24)
  })
};

var MenuItem =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(MenuItem, _PureComponent);

  function MenuItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "getItemProps", function (props) {
      if (props === void 0) {
        props = {};
      }

      var _props = props,
          disabled = _props.disabled,
          onClick = _props.onClick,
          render = _props.render,
          tabIndex = _props.tabIndex,
          restProps = _objectWithoutPropertiesLoose(_props, ["disabled", "onClick", "render", "tabIndex"]);

      return _objectSpread({}, render ? restProps : {}, {
        'aria-disabled': disabled,
        disabled: disabled,
        tabIndex: tabIndex !== undefined ? tabIndex : disabled ? '-1' : 0
      }, !render ? restProps : {}, !disabled ? {
        onClick: onClick,
        onKeyDown: _this.onKeyDown
      } : {});
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var onClick = _this.props.onClick;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick && onClick(event);
      }
    });

    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        iconEnd = _this$props.iconEnd,
        iconStart = _this$props.iconStart,
        render = _this$props.render,
        secondaryText = _this$props.secondaryText,
        variant = _this$props.variant;

    if (render) {
      return render({
        props: this.getItemProps(this.props)
      });
    }

    var rootProps = this.getItemProps(this.props);
    var startIcon = variant !== undefined && variant && variantIcons[variant];

    if (iconStart) {
      startIcon = cloneElement(iconStart, {
        size: pxToEm(24),
        key: 'iconStart'
      });
    }

    var endIcon = iconEnd && cloneElement(iconEnd, {
      size: pxToEm(24),
      key: 'iconEnd'
    });
    return ___EmotionJSX(Root, rootProps, ___EmotionJSX(MenuItemInner, null, startIcon, (children || secondaryText) && ___EmotionJSX(MenuItemContent, null, ___EmotionJSX(MenuItemText, null, children), secondaryText && ___EmotionJSX(MenuItemSecondaryText, null, secondaryText)), endIcon));
  };

  return MenuItem;
}(PureComponent);

_defineProperty(MenuItem, "displayName", 'MenuItem');

export { MenuItem as default };
MenuItem.propTypes = process.env.NODE_ENV !== "production" ? menuItemPropTypes : {};